export default (function () {
    if (!document.body.scrollTo) {
        // @ts-ignore
        Element.prototype.scrollTo = function (obj: { left: number; top: number }) {
            this.scrollLeft = obj.left;
            this.scrollTop = obj.top;
        };
    }

    if (!document.body.scrollBy) {
        // @ts-ignore
        Element.prototype.scrollBy = function (obj: { left: number; top: number }) {
            this.scrollLeft += obj.left;
            this.scrollTop += obj.top;
        };
    }
})();
